import React, { useEffect, useState } from "react";
import {
  View,
  Platform,
  UIManager,
  ViewProps,
  LayoutAnimation,
  TouchableOpacity,
} from "react-native";

import { sizes } from "assets/constants";

if (
  Platform.OS === "android" &&
  UIManager.setLayoutAnimationEnabledExperimental
) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

export default function Accordion(props: AccordionT & ViewProps) {
  const { renderHeader, renderContent, autoToggle, expanded, onPress, style } =
    props;

  const [expandedState, setExpandedState] = useState(expanded ?? false);

  const open = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setExpandedState(true);
  };

  const close = () => {
    LayoutAnimation.configureNext(
      LayoutAnimation.create(100, "easeInEaseOut", "scaleY")
    );
    setExpandedState(false);
  };

  const toggle = () => {
    LayoutAnimation.configureNext(
      LayoutAnimation.create(100, "keyboard", "scaleY")
    );
    setExpandedState(!expandedState);
  };

  useEffect(() => {
    expanded ? open() : close();
  }, [expanded]);

  const _onPress = () => {
    autoToggle ? toggle() : onPress && onPress(open, close, expandedState);
  };
  return (
    <View style={style}>
      <TouchableOpacity
        onLongPress={props?.onLongPress}
        onPress={_onPress}
        activeOpacity={sizes.tapOpacity}
      >
        {renderHeader(expandedState)}
      </TouchableOpacity>
      {expandedState && renderContent()}
    </View>
  );
}
